/* eslint-disable func-names */
import { Suspense } from 'react';
import { ROUTE_LOADING_TYPE } from '@constants/index';
import RouteLoading from './RouteLoading';

const LazyLoadRoute = Component =>
  function (props) {
    return (
      <Suspense
        fallback={
          <RouteLoading type={ROUTE_LOADING_TYPE.ROUTE_LAZY_LOADING} />
        }>
        <Component {...props} />
      </Suspense>
    );
  };

export default LazyLoadRoute;
